import { ReactNode, useMemo, useState } from 'react';
import styles from './SelectMetricDropDown.module.scss'
import {
    FiChevronDown as ExpandDropdownIcon,
    FiChevronUp as CollapseDropdownIcon,
} from "react-icons/fi";
import { AiOutlineSearch as SearchIcon } from "react-icons/ai";

import Select, { StylesConfig, components } from 'react-select';
import { defaultTheme } from 'react-select';
import { TypeOfFinanceOption } from '../../../../interfaces/interfaces';

const { colors } = defaultTheme;

type Props = {
    options: {
        id: number;
        label: string;
        type: TypeOfFinanceOption,
        value: string;
        feLabel?: string;
    }[],
    handleSelectedValue: (value) => void,
    value: any;
    errorBorder?: boolean;
}

const SelectMetricCustomDropDown = ({ options, handleSelectedValue, value, errorBorder }: Props) => {
    const [isOpen, setIsOpen] = useState(false);
    // const [value, setValue] = useState(null);
    console.log('value', value)

    // console.log('value', value, "isOpen", isOpen);

    const sliceLabel = useMemo(() => {
        if (value && value?.feLabel.toString().length > 25) {
            return `${value?.feLabel.slice(0, 30)}...`
        } else {
            return value?.feLabel
        }
    }, [value])

    return (
        <Dropdown
            isOpen={isOpen}
            onClose={() => {
                setIsOpen(false)
            }}
            target={
                <button
                    type='button'
                    className={`${styles.dropdownBtn} ${errorBorder ? styles.errorBorder: ''}`}
                    // iconAfter={<ChevronDown />}
                    onClick={(e) => {
                        e.stopPropagation();
                        // console.log('onClick')
                        setIsOpen((prev) => !prev)
                    }}
                // isSelected={isOpen}
                >
                    <div className={styles.btnContainer}>
                        <div className={styles.btnText}>
                            {value?.feLabel ? `${sliceLabel}` : 'Select Metric'}
                        </div>
                        <div className={styles.iconContainer}>
                            <ExpandDropdownIcon />
                        </div>
                    </div>
                </button>
            }
        >
            {
                options?.map(option => {
                    return (
                        <div className={`${styles.dropDownEle} ${value?.label == option?.label ? styles.selected : ''}`} 
                            onClick={() => {
                                setIsOpen(open => !open)
                                handleSelectedValue(option)
                            }}
                        >{option?.label}</div>
                    )
                })
            }
        </Dropdown>
    );
};


export default SelectMetricCustomDropDown;
// styled components

const Menu = (props: JSX.IntrinsicElements['div']) => {
    const shadow = 'hsla(218, 50%, 10%, 0.1)';
    return (
        <div
            className={styles.menu}
            {...props}
        />
    );
};
const Blanket = (props: JSX.IntrinsicElements['div']) => (
    <div
        className='blanket'
        style={{
            bottom: 0,
            left: 0,
            top: 0,
            right: 0,
            position: 'fixed',
            zIndex: 2000,
        }}
        {...props}
    />
);
const Dropdown = ({
    children,
    isOpen,
    target,
    onClose,
}: {
    children?: ReactNode;
    readonly isOpen: boolean;
    readonly target: ReactNode;
    readonly onClose: () => void;
}) => (
    <div
        className={styles.dropdownContainer}
    // style={{ position: 'relative', zIndex: "1059" }}
    >
        {target}
        {isOpen ? <Menu>{children}</Menu> : null}
        {isOpen ? <Blanket onClick={onClose} /> : null}
    </div>
);